const host = process.env.REACT_APP_API_BASE_URL || "http://localhost:8980";
const baseUrl = `${host}/bot/v1`;

export default {
	checkApiKey: `${baseUrl}/team/apiKey`,
	lookup: "https://extreme-ip-lookup.com/json",
	verifyIdentity: `${baseUrl}/identify/contact/:id`,
	createIdentity: `${baseUrl}/identify/contact`,
};
